import { isTablet, isMobile } from 'react-device-detect';

export const isTabletOrMobile = isTablet || isMobile;
